import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { Button } from "../../../../../../../../components/ui/Button";
import I18n from "../../../../../../../localization/I18n";

export const OrgStakeholderEmails: React.FC<{
  itemIds: number[];
  stakeholders: FP.Entities.IStakeholderSummary[];
}> = observer(({ itemIds, stakeholders }) => {
  const emails = useMemo(() => {
    return stakeholders.filter(item => itemIds.includes(item.id)).map(e => e.email);
  }, [itemIds, stakeholders]);

  const emailList = emails.join(",");

  return (
    <div className="stakeholder-email container-fluid py-6">
      <div className="row">
        <div className="col">
          <h1 className="mb-1">Email Addresses</h1>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <ul className="my-0 mb-3">
            {emails?.length > 0
              ? emails.map((email, i) => {
                  return (
                    <li className="stakeholder-email__list" key={i}>
                      <p className="mb-0">{email}</p>
                    </li>
                  );
                })
              : I18n.t("phrases.actionStakeholders_noEmailAddresses")}
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Button
            onClick={() => {
              navigator.clipboard.writeText(emailList);
            }}
            className="mr-2"
          >
            {I18n.t("phrases.copyToClipboard")}
          </Button>
        </div>
      </div>
    </div>
  );
});
